module.exports = __webpack_public_path__ + "media/2.cdeb76d3.mp4";